import { useEffect, useMemo } from "react";
import { useAvailableLinesStore } from "../../stores/hashs/useAvailableLinesStore";
import { useDateStore } from "../../stores/useDateStore";
import { useTripsStore } from "../../stores/useTripsStore";
import { useNotEscaletedLinesTodayStore } from "../../stores/hashs/useNotEscaletedLinesTodayStore";

export function useNotEscaletedLinesToday() {

    const {
        data: availableLines,
        totalToday
    } = useAvailableLinesStore();

    const today = useDateStore(state => state.today);
    const currentDayLabel = useDateStore(state => state.currentDayLabel);

    const tripsMap = useTripsStore(state => state.tripsMap);

    const setNotEscaletedLinesToday =
        useNotEscaletedLinesTodayStore(
            state => state.setNotEscaletedLinesToday
        );

    const value = useMemo(() => {

        const data = [];

        for (const linha of availableLines) {
            if (!linha.today) {
                continue;
            }

            const tripUid = `${today}-${String(linha.CODIGO_INTEGRACAO)}`;

            if (tripsMap.has(tripUid)) continue;

            data.push(linha);
        }

        const total = data.length;

        return {
            data,
            total,
            totalDay: totalToday,
            percentTotal:
                totalToday
                    ? Math.round(total / totalToday * 100)
                    : 0,
            title:
                `LINHA${total > 1 ? 'S' : ''} NÃO ESCALADA${total > 1 ? 'S' : ''} PARA ${currentDayLabel}`
        };

    }, [
        availableLines,
        totalToday,
        today,
        tripsMap,
        currentDayLabel
    ]);

    useEffect(() => {

        setNotEscaletedLinesToday(value);

    }, [
        value,
        setNotEscaletedLinesToday
    ]);

}